<template>
    <div class="wrapper">
        <div class="spinner">
            <div class="circle">
                <div class="inner-circle"></div>
            </div>
            <div
                ref="loadingDot1"
                class="loading-dot-wrapper"
                :class="{ '--is-mounting': !isMounted }"
            >
                <div class="loading-dot"></div>
            </div>
            <div
                ref="loadingDot2"
                class="loading-dot-wrapper"
                :class="{ '--is-mounting': !isMounted }"
                style="opacity: 0.8"
            >
                <div
                    ref="loadingSquash"
                    class="loading-dot"
                    style="transform: translateY(-0.4rem) scale(1.4)"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import gsap from 'gsap';

    const loadingDot1 = ref();
    const loadingDot2 = ref();

    const loadingSquash = ref();

    const isMounted = ref(false);

    onMounted(() => {
        const loadingDots = [loadingDot1.value, loadingDot2.value];

        isMounted.value = true;

        const loadingAnimTl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.4
        });
        loadingAnimTl.to(loadingDots, {
            rotation: 360,
            duration: 1.6,
            stagger: 0.015,
            ease: 'power1.inOut'
        });

        loadingAnimTl.to(
            loadingSquash.value,
            {
                scaleX: 1.4,
                scaleY: 0.9,
                repeatDelay: 0.2,
                duration: 1.6 / 2,
                ease: 'linear'
            },
            '<'
        );
        loadingAnimTl.to(
            loadingSquash.value,
            {
                scaleX: 1.4,
                scaleY: 1.4,
                repeatDelay: 0.2,
                duration: 1.6 / 2,
                ease: 'linear'
            },
            '>'
        );
    });
</script>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/loading-spinner.scss';
</style>
